define([
    "angular",
    "../extension/extension"
], function (angular) {
    "use strict";

    return angular.module("transitionsModule", [
        "extensionModule"
    ]);
});